import { css } from 'styled-components';

import { Cluster } from './Cluster';
import { ExpandedButton } from './ExpandedButton';
import { LayersControls } from './LayersControls';
import { LayersMessages } from './LayersMessages';
import { Markers } from './Markers';
import { Zoom } from './Zoom';

export const MapStyles = css`
  .mapboxgl-map {
    z-index: 1;

    /* перебиваем стандартый шрифт mapbox */
    position: sticky !important;
    top: 60px;

    button {
      cursor: pointer;
    }

    .mapboxgl-ctrl-bottom-right {
      display: none;
    }

    .overlay_container {
      position: absolute;
      top: 33%;
      left: 50%;
      width: 330px;
      height: 280px;
      margin-left: -140px;
    }

    .map_disabled_icon {
      background: url('../../images/search/map-disabled.svg') no-repeat;

      width: 77px;
      height: 55px;
      margin-top: 30px;
      margin-bottom: 15px;
    }

    .hotel-card-popup {
      z-index: 100 !important;
      width: 320px;
      button {
        font-size: 12px;
      }

      .mapboxgl-popup-content {
        padding: 0;

        > div {
          > div {
            margin: 0;
          }
        }
      }
    }
  }

  ${ExpandedButton}

  ${LayersControls}

  ${LayersMessages}

  ${Markers}

  ${Cluster}

  ${Zoom}
`;
